var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApply(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.182,
    height: 55.117,
    viewBox: "0 0 56.182 55.117",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "apply",
    transform: "translate(0 6.524)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_192_",
    d: "M228.02,197.641a17.228,17.228,0,0,0-8.186-6.229l-.288-.111h-15.57V204.37l10.2,10.2h14.151v-16.5Z",
    transform: "translate(-181.593 -176.118)",
    fill: "#a9aed8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_190_",
    d: "M225.084,16.233a12.2,12.2,0,0,0-6.86,2.1l-.73.493V35.516l4.339,4.814.512.117a12.261,12.261,0,1,0,2.739-24.213Z",
    transform: "translate(-193.628 -20.26)",
    fill: "#b1b7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3742_",
    d: "M286.664,16.233V40.754a12.26,12.26,0,1,0,0-24.521Z",
    transform: "translate(-255.208 -20.26)",
    fill: "#989fd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3556_",
    d: "M35.962,200.514l-.042-.086a17.9,17.9,0,0,0-9.929-9.017L25.7,191.3H12.709l-.288.111C4.876,194.321,0,201.987,0,210.944v13.767H42.254Z",
    transform: "translate(0 -176.118)",
    fill: "#989fd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_201_",
    d: "M175.03,224.71h23.048l-6.292-24.2-.042-.086a17.9,17.9,0,0,0-9.929-9.017l-.288-.111h-6.5V224.71Z",
    transform: "translate(-155.824 -176.118)",
    fill: "#6a75b9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_4005_",
    cx: 12.26,
    cy: 12.26,
    r: 12.26,
    transform: "translate(4.456 -0.885) rotate(-13.3)",
    fill: "#a5aad5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_48_",
    d: "M272.667,242.541a13.893,13.893,0,0,0,0,27.787c7.661,0,12.8-6.233,12.8-13.893S280.328,242.541,272.667,242.541Z",
    transform: "translate(-230.378 -221.735)",
    fill: "#e6f3fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4181_",
    d: "M385.387,242.541v27.787a13.893,13.893,0,0,0,0-27.787Z",
    transform: "translate(-343.098 -221.735)",
    fill: "#d1e9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_261_",
    d: "M340.768,316.618h-4.627v-4.627H332.85v4.627h-4.627v3.292h4.627v4.627h3.292V319.91h4.627Z",
    transform: "translate(-292.207 -283.564)",
    fill: "#ff9100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_202_",
    d: "M175.03,16.233V40.754a12.26,12.26,0,0,0,0-24.521Z",
    transform: "translate(-155.824 -20.26)",
    fill: "#5e69b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4183_",
    d: "M387.033,316.618v-4.627h-1.646v12.545h1.646V319.91h4.627v-3.292Z",
    transform: "translate(-343.098 -283.564)",
    fill: "#d88d2e"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApply);
export default __webpack_public_path__ + "static/media/apply.86b33e824665977d07974fae096b69d2.svg";
export { ForwardRef as ReactComponent };